import Vue from 'vue';
import Router from 'vue-router';
import config from '@/config';
import {getToken} from '@/utils/cookie';
import {
  getAccessToken,
  refreshToken,
  getErpconfig,
  nonexistent,
  getSinglePageRoleCommon,
  getQueryMenu,
  getSinglePageHelp,
  checkAppVersion,
} from '@/utils/user';

import {
  isBillConfirmed,
  getConfigurationItemData,
  getSupplierConfigurationItemData,
  getRouteMenuKey,
  showPageInitFailureModal,
  isInterceptorHandled,
  resetInterceptorHandled,
  isChunkLoadError,
  getRouteWithoutTicket,
  ensureSaasParamKeysData,
} from '@/utils/common';
import {validateConfigRouteAccess} from '@/utils/configRouteGuard';
import {clearAllLoading} from '@/utils/loading';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);
let countTime = config.curTime;
const routes = [
  {
    path: '/',
    redirect: '/statistics',
    component: () => import('@/components/layout/main'), // 引入主文件
    children: [
      {
        path: '/statistics', // 即时经营数据
        component: () => import('@/views/supplier/components/statistics/statistics')
      },
      {
        path: '/noPersermission',
        component: () => import('@/components/common/noPersermission')
      },
      {
        path: '/collectionOrderList', // 订单中心---集货订单列表
        component: () => import('@/views/supplier/components/supplierOrder/collectionOrderList')
      },
      {
        path: '/directDeliveryOrderList', // 订单中心---直发订单列表
        component: () => import('@/views/supplier/components/supplierOrder/directDeliveryOrderList')
      },
      {
        path: '/shipmentRecord', // 订单中心---发货记录
        component: () => import('@/views/supplier/components/supplierOrder/shipmentRecord')
      },
      {
        path: '/shipmentRecordDetails', // 订单中心---查看发货记录详情
        component: () => import('@/views/supplier/components/supplierOrder/shipmentRecordDetails')
      },
      {
        path: '/additionalGoods', // 订单中心---追加货品
        component: () => import('@/views/supplier/components/supplierOrder/additionalGoods'),
        meta: {
          parentPath: '/shipmentRecord'
        }
      },
      {
        path: '/stockList', // 订单中心---备货单
        component: () => import('@/views/supplier/components/supplierOrder/stockList')
      },
      {
        path: '/initiateStocking', // 订单中心---发起备货
        component: () => import('@/views/supplier/components/supplierOrder/initiateStocking'),
        meta: {
          parentPath: '/stockList'
        }
      },
      {
        path: '/stockOrderDetails', // 订单中心---备货单--备货单详情
        component: () => import('@/views/supplier/components/supplierOrder/stockOrderDetails'),
        meta: {
          parentPath: '/stockList'
        }
      },
      {
        path: '/productCenter/productGoods', // 商品中心---商品管理
        component: () => import('@/views/supplier/components/productCenter/productGoods')
      },
      {
        path: '/supplierViewSku', // 商品中心---商品管理---商品列表---查看SKU
        component: () => import('@/components/common/viewSku'),
        meta: {
          parentPath: '/productCenter/productGoods'
        }
      },
      {
        path: '/productDetails', // 商品中心---商品管理---商品列表---新增/编辑商品
        component: () => import('@/components/common/productDetails'),
        meta: {
          parentPath: '/productCenter/productGoods'
        }
      },
      {
        path: '/collectProducts', // 商品中心---商品管理---商品列表---采集1688商品
        component: () => import('@/views/supplier/components/productCenter/collectProducts'),
        meta: {
          parentPath: '/productCenter/productGoods'
        }
      },
      {
        path: '/productCenter/productBrand', // 商品中心---品牌管理
        component: () => import('@/views/supplier/components/productCenter/productBrand')
      },
      {
        path: '/addressLibraryManageList', // 地址库管理
        component: () => import('@/views/supplier/components/addressLibraryManage/addressLibraryManageList')
      },
      {
        path: '/reconciliationManage', // 对账管理列表
        component: () => import('@/views/supplier/components/reconciliationManage/reconciliationBill')
      },
      {
        path: '/reconciliationBillDetails', // 对账管理列表详情
        component: () => import('@/views/supplier/components/reconciliationManage/reconciliationBillDetails'),
        meta: {
          parentPath: '/reconciliationManage'
        }
      },
      {
        path: '/messageCenter', // 消息中心
        component: () => import('@/views/supplier/components/messageManage/messageCenter')
      },
      {
        path: '/messageMailboxes', // 消息中心---短信、邮箱查看
        component: () => import('@/views/supplier/components/messageManage/messageMailboxes'),
        meta: {
          parentPath: '/messageCenter'
        }
      },
      {
        path: '/importTask', // 导入/导出任务--导入查看
        component: () => import('@/views/supplier/components/importExportTask/importTask')
      },
      {
        path: '/exportTask', // 导入/导出任务--导出查看
        component: () => import('@/views/supplier/components/importExportTask/exportTask')
      },
      {
        path: '/accountManage/basicInformation', // 账户管理--基本信息
        component: () => import('@/views/supplier/components/accountManage/basicInformation')
      },
      {
        path: '/accountManage/management', // 账户管理--员工管理
        component: () => import('@/views/supplier/components/accountManage/management')
      },
      {
        path: '/accountManage/collectionAccount', // 账户管理--收款账户
        component: () => import('@/views/supplier/components/accountManage/collectionAccount')
      },
      {
        path: '/supplierWarehouseManage', // 仓储与物流--仓库管理
        component: () => import('@/views/supplier/components/warehouseLogistics/supplierWarehouseManage')
      },
      {
        path: '/supplierLogisticsManage', // 仓储与物流--物流管理
        component: () => import('@/views/supplier/components/warehouseLogistics/supplierLogisticsManage')
      },
      {
        path: '/warehouseCostAllocation', // 仓储与物流--仓库费用配置
        component: () => import('@/views/supplier/components/warehouseLogistics/warehouseCostAllocation')
      },
      {
        path: '/platformAuthorization', // 第三方平台--平台授权
        component: () => import('@/views/supplier/components/thirdPartyPlatform/platformAuthorization')
      }
    ]
  },
  {
    path: '/printPickList', // 打印拣货单
    component: resolve => {
      require(['@/views/supplier/components/wms/exWarehouse/printPickList.vue'], resolve);
    }
  },
  {
    path: '/printPickListBatch', // 批量打印拣货单
    component: resolve => {
      require(['@/views/supplier/components/wms/exWarehouse/printPickListBatch.vue'], resolve);
    }
  },
  {
    path: '/sortingInfo', // 扫描多品分拣
    component: resolve => {
      require(['@/views/supplier/components/wms/exWarehouse/sortingInfo.vue'], resolve);
    }
  },
  {
    path: '/packingWork', // 扫描拣货复核
    component: resolve => {
      require(['@/views/supplier/components/wms/exWarehouse/packingWork.vue'], resolve);
    }
  },
  {
    path: '/packingWork/prepareGoods', // 扫描拣货复核(备货)
    component: resolve => {
      require(['@/views/supplier/components/wms/exWarehouse/packingWorkPg.vue'], resolve);
    }
  },
  {
    path: '/printPaperList', // 批量打印纸质清单
    component: resolve => {
      require(['@/views/supplier/components/supplierOrder/printPaperList.vue'], resolve);
    }
  },
  {
    path: '/viewGuideContent', // 查系统指引内容
    component: resolve => {
      require(['@/components/layout/viewGuideContent.vue'], resolve);
    }
  },
  {
    path: '/productDetailsByExternal', // 商品中心---商品管理---商品列表---新增/编辑商品
    component: () => import('@/components/common/productDetails'),
    meta: {
      parentPath: '/productCenter/productGoods'
    }
  },
  {
    path: '/commonHelpCenter', // 帮助中心
    component: () => import('@/components/common/commonHelpCenter.vue')
  }
];
const router = new Router({
  mode: 'hash',
  routes
});

/**
 * 初始化供应商系统页面进入前需要的基础数据。
 * @param {string} menuKey 当前路由对应的菜单 key。
 * @param {Object} to 目标路由对象。
 * @returns {Promise<boolean>} 初始化成功返回 true，否则抛出异常或返回 false。
 */
const initPageData = async (menuKey, to) => {
  const menu = await getQueryMenu();
  if (menu === null) {
    clearAllLoading();
    return null;
  }
  if (menu === false) {
    throw new Error('getQueryMenu failed');
  }
  const [erp, role] = await Promise.all([
    getErpconfig(''),
    getSinglePageRoleCommon(menuKey),
    isBillConfirmed(to),
  ]);
  if (erp === false) {
    throw new Error('getErpconfig failed');
  }
  if (role === false) {
    throw new Error('getSinglePageRoleCommon failed');
  }
  getSinglePageHelp(menuKey, 'ymsSupplier').catch((e) => {
    console.error('getSinglePageHelp non-blocking error:', e);
  });
  await getConfigurationItemData();
  return true;
}

/**
 * 统一处理供应商系统页面初始化失败场景。
 * @param {Function} next vue-router 导航回调。
 * @param {Error} error 当前初始化异常。
 */
const handlePageInitFailure = (next, error) => {
  console.error('supplier router beforeEach error:', error);
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  next(false);
  if (isInterceptorHandled) {
    resetInterceptorHandled();
    return;
  }
  showPageInitFailureModal();
}

// 路由前置守卫
router.beforeEach(async (to, from, next) => {
  try {
    // 前置检测：版本是否已更新
    const versionChanged = await checkAppVersion();
    if (versionChanged) {
      window.location.reload();
      return;
    }

    localStorage.setItem('system', 'supplier');
    const token = getToken();
    const menuKey = getRouteMenuKey(to, 'supplier');
    // 无权限页直接放行
    if (to.path === '/noPersermission') {
      await initPageData(menuKey, to);
      clearAllLoading();
      return next();
    }
    // token 处理
    let justLoggedIn = false;
    // 有 token 且不是外部商品详情页
    if (token && to.path !== '/productDetailsByExternal') {
      refreshToken(countTime);
    } else {
      // 无 token 或外部商品详情页，先换 token
      const access = await getAccessToken(to.fullPath);
      if (!access) {
        throw new Error('getAccessToken failed');
      }
      refreshToken(countTime);
      if (!token) {
        justLoggedIn = true;
      }
    }
    // token 就绪后：登录成功或整页刷新时拉取 SaaS 配置
    await ensureSaasParamKeysData(to, justLoggedIn);
    const routeWithoutTicket = getRouteWithoutTicket(to);
    if (routeWithoutTicket) {
      clearAllLoading();
      return next(routeWithoutTicket);
    }
    // 初始化页面依赖
    const passed = await initPageData(menuKey, to);
    if (passed === null) {
      resetInterceptorHandled();
      return next(false);
    }
    // 配置项路由访问验证
    const configRouteAccess = validateConfigRouteAccess(to, 'supplier');
    if (!configRouteAccess) {
      return next(false);
    }
    if (passed) {
      getSupplierConfigurationItemData();
      clearAllLoading();
      return nonexistent(to, next);
    }
  } catch (e) {
    handlePageInitFailure(next, e);
  }
});
// 路由错误处理
router.onError((error) => {
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  console.error('supplier router error:', error);
});

export default router;
